import { curry, get, omit, set } from 'lodash/fp';

export const renameProperty = curry(
  // eslint-disable-next-line @typescript-eslint/ban-types
  <T extends object | null | undefined>(
    oldKey: keyof T,
    newKey: keyof T,
    object: T,
  ) =>
    // Set the new key to the value of old key and omit old key
    set(newKey, get(oldKey, object), omit(oldKey, object)),
);
